// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————— EVENT HANDLERS ———————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// —————————————————————————————————————— INIT. METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function init_flkty() {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const { wrpr_slides, btn_prev, btn_next, btns_pagination } = this.ref;

  const { autoPlay = false } = this.options;

  //////////////////////////////////////////// ACTION ////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const inst_flickity = new Flickity(wrpr_slides, {
    cellSelector: "[g-ref='slides']",
    wrapAround: true,
    cellAlign: "center",
    contain: false,
    pageDots: false,
    prevNextButtons: false,
    selectedAttraction: 0.01,
    friction: 0.2,
    draggable: true,
    imagesLoaded: true,
    lazyLoad: 1,
    autoPlay: autoPlay,
    pauseAutoPlayOnHover: false,
    on: {
      /////////// Slider ready event hdl. ////////////
      ////////////////////////////////////////////////

      // ready: () => {
      //   if (this.options.logs) console.log("Slider ready.");
      // },

      /////////// Slide change event hdl. ////////////
      ////////////////////////////////////////////////

      change: (index_activeSlide) => {
        this.setState({ index_activeSlide });

        // Update pagination btns. //
        if (btns_pagination.length)
          btns_pagination.forEach((btn) => {
            const index_btn = parseInt(btn.dataset.index);
            btn.dataset.active = index_btn === index_activeSlide ? "true" : "false";
          });
      },
    },
  });

  // Prev./Next btns. init. //
  ////////////////////////////////////

  if (btn_prev) btn_prev.addEventListener("click", () => inst_flickity.previous());
  if (btn_next) btn_next.addEventListener("click", () => inst_flickity.next());

  // Pagination btns. init. //
  ////////////////////////////////////

  if (btns_pagination.length)
    btns_pagination.forEach((btn) =>
      btn.addEventListener("click", () => {
        const index = parseInt(btn.dataset.index);
        inst_flickity.select(index);
        btn.dataset.active = "true";
        btns_pagination.filter((b) => b !== btn).forEach((b) => (b.dataset.active = "false"));
      }),
    );

  /////////////////////////////////////////// Conclude ///////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  // ...
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
